import type { ID } from '@octopus-do/octopus-project-core'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Folder } from '@octopus-do/octopus-storybook/icons'
import type {
  WorkspaceBase,
  WorkspaceItem,
} from '@store/reducers/dashboard/types'
import type React from 'react'

import { WorkspacesContent } from './components'

interface Props {
  workspaces: WorkspaceBase[]
  folders: WorkspaceItem[]
  currentFolder: ID | null
  disabled: boolean
}

export const ProjectMoveMenu: React.FC<Props> = ({
  workspaces,
  disabled,
  currentFolder,
  folders,
}) => {
  const validFolders = folders
    .filter((f) => f.type === 'folder')
    .filter((f) => f.id !== currentFolder)

  const empty = validFolders.length + workspaces.length === 0

  if (disabled || empty) {
    return null
  }

  return (
    <DropdownMenu.NestedMenu
      content={WorkspacesContent}
      icon={Folder}
      id="move"
      title="Move to"
      showDashboard={Boolean(currentFolder)}
      workspaces={workspaces}
      folders={validFolders}
    />
  )
}
